// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"96076441","618":"62fd8870"}[chunkId] + ".chunk.js";
};